define([], () => ({
        log({category, eventName, payload}) {
            const timestamp = new Date().toString();
            console.log(timestamp, category, eventName, payload);
        }
    })
);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/tracking/adapters/ConsoleLogAdapter.js